import { render, staticRenderFns } from "./modalAddHours.vue?vue&type=template&id=54f763e8&scoped=true"
import script from "./modalAddHours.vue?vue&type=script&lang=js"
export * from "./modalAddHours.vue?vue&type=script&lang=js"
import style0 from "./modalAddHours.vue?vue&type=style&index=0&id=54f763e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f763e8",
  null
  
)

export default component.exports